export function convertToTitleCase(str) {
  if (!str) {
    return '';
  }
  return str.toLowerCase().replace(/\b\w/g, (s) => s.toUpperCase());
}

export function formatURL(input) {
  try {
    if (!/^([a-zA-Z0-9.-]+\.[a-zA-Z]{2,}|https?:\/\/\S+)$/i.test(input.trim())) return null;
    let url = new URL(input.includes('://') ? input : 'https://' + input);
    if (!['http:', 'https:'].includes(url.protocol)) return null;
    return url.href;
  } catch (e) {
    return null;
  }
}
